let currentQuickView = window.bvaccel && window.bvaccel.product ? window.bvaccel.product : {};
let currentCollection = '';

((QuickView, $) => {
  'use strict';

  let filteredVariants = {};
  let quickViewSettings = {};
  let colorPrefix =  ``;

  const $dom = {};

  const cacheDom = () => {
    $dom.productImageWrapper = $('.js-image-wrapper');
    $dom.quickViewCTA = $('.js-quickview-cta');
  };

  /* Borrowed Code from Product.js */
  const initSettings = () => {
    quickViewSettings = {};
    colorPrefix =  ``;
    $('.js-quickview-product-variant-option-selector').each(function () {
      const optionName = $(this).data('name');
      const optionNum = $(this).data('option');
      const value = $(this).val();
      quickViewSettings[optionNum] = {
        name: optionName,
        value: value,
      };
    });
  };

  const initDisabledSizes = () => {
    const keys = Object.keys(quickViewSettings);
    const nonSizeOptionKeys = keys.filter(
      (key) => quickViewSettings[key] && quickViewSettings[key].name.toString().toLowerCase() != 'size'
    );
    const sizeOptionKeys = keys.filter(
      (key) => quickViewSettings[key] && quickViewSettings[key].name.toString().toLowerCase() == 'size'
    );
    if (sizeOptionKeys.length > 0) {
      const sizeOption = sizeOptionKeys[0];
      const productVariants = currentQuickView.variants;
      const matchingVariants = productVariants.filter((variant) => {
        for (let i = 0; i < nonSizeOptionKeys.length; i++) {
          if (
            variant[nonSizeOptionKeys[i]].toString().toLowerCase() !==
            quickViewSettings[nonSizeOptionKeys[i]].value.toString().toLowerCase()
          ) {
            return false;
          }
        }
        return true;
      });

      $('.js-quickview-product-variant-size').each(function () {
        $(this).removeClass('is-disabled');
        let $that = $(this);
        const matchingSizeVariant = matchingVariants.filter((variant) => {
          if (variant[sizeOption].toString().toLowerCase() === $that.data('value').toString().toLowerCase()) {
            return true;
          }
        });
        if (matchingSizeVariant.length < 1 || (matchingSizeVariant.length > 0 && !matchingSizeVariant[0].available)) {
          $(this).addClass('is-disabled');
          if ($(this).hasClass('is-active')) {
            $(this).removeClass('is-active');
          }
        } else if (
          $(this).data('value').toString().toLowerCase() ===
          quickViewSettings[sizeOption].value.toString().toLowerCase()
        ) {
          $(this).addClass('is-active');
        }
      });

      $('.js-quickview-product-variant-size.is-disabled').each(function () {
        const $before = $(this).find('.product--variant-size-disabled-before');
        const $after = $(this).find('.product--variant-size-disabled-after');
        const opposite = $(this).outerHeight();
        const adjacent = $(this).outerWidth();
        const deg = Math.atan(opposite / adjacent) * (180 / Math.PI);
        $before.css({ transform: `skewY(${deg}deg)` });
        $after.css({ transform: `skewY(-${deg}deg)` });
      });
    }
  };

  const changeVariantOption = ($that) => {
    if (!($that.hasClass('is-active') || $that.hasClass('is-disabled'))) {
      const $display = $that.closest('.product--variant-display');
      const $displayList = $display.find('.product--variant-display-list');
      const $selectList = $(`.js-quickview-product-variant-option-selector[data-name='${$displayList.data('name')}']`);
      $selectList.find('option').each(function () {
        if ($(this).val().toString().toLowerCase() === $that.data('value').toString().toLowerCase()) {
          $selectList.val($(this).val()).change();
          return false;
        }
      });

      $display.find('.is-active').removeClass('is-active');
      $that.addClass('is-active');

      const swatchId = $that.data(`swatch-id`);
      if (!swatchId) return;
      let slideNum = 0;
      $('.product--images-featured-slide-image[data-variant-ids]').each(function () {
        const variantIds = $(this).data(`variant-ids`);
        if (variantIds && variantIds.includes(swatchId)) {
          slideNum = $(this).parent().attr('data-slick-index');
        }
      });
      slideNum = Number(slideNum);
      if (slideNum < 0) {
        slideNum = 0;
      }
      const $featuredSlider = $('.js-quickview-product-featured-slider');
      if ($featuredSlider.hasClass(`slick-initialized`)) {
        $featuredSlider.slick('slickGoTo', slideNum);
      }
      const $variantOptionControl = $that.closest(`.js-variant-option-control`);
      const optionName = $variantOptionControl.data(`name`);
      if (optionName === `Color`) {
        colorPrefix = $that.data(`color-prefix`) || ``;
      }
    }
  };

  const filterVariants = () => {
    let tempArray = currentQuickView.variants.slice();
    Object.keys(quickViewSettings).forEach((key) => {
      tempArray = tempArray.filter((variant) => {
        return variant[key] === quickViewSettings[key].value;
      });
    });
    filteredVariants = tempArray.slice();
    if (filteredVariants.length == 1) {
      const currentVariant = filteredVariants[0];
      const currentPrice = currentVariant.price / 100;
      const comparePrice = currentVariant.compare_at_price && currentVariant.compare_at_price / 100;
      const $price = $(`.quickview-product .product--price`);
      const $comparePrice = $(`.quickview-product .product--title-price-compare`);
      const $pricingDisclaimer = $(`.quickview-product .js-pricing-disclaimer`);
      $price.text(`$${currentPrice.toFixed(2)}`);
      if (!comparePrice || comparePrice <= currentPrice) {
        $comparePrice.hide();
        $pricingDisclaimer.hide();
      } else {
        $comparePrice.find(`.money`).text(`$${comparePrice.toFixed(2)}`);
        $comparePrice.show();
        $pricingDisclaimer.show();
      }
      if (currentVariant.available) {
        $('.js-quickview-atc-button').prop('disabled', false).removeClass('disabled');
        const addToCartCta = window.bvaccel.isBundleCollection ? 'Add to Bundle' : 'Add to Cart';
        $('.js-quickview-atc-button-text').html(addToCartCta);
        $('.js-quickview-variant-selector').val(currentVariant.id).change();
      } else {
        $('.js-quickview-atc-button').prop('disabled', true).addClass('disabled');
        $('.js-quickview-atc-button-text').html('Sold Out');
      }
      if (window.bvaccel.isBundleCollection) {
        applyBundlePricing();
      }
    }
  };

  const loadModalContent = async (productHandle, view) => {
    const url = `products/${productHandle}`;
    const data = await getAlternativeTemplate(url, view);
    return data;
  };

  const getAlternativeTemplate = async (resource, templateName, json = false) => {
    const url = `/${resource}?view=${templateName}`;
    const options = { credentials: 'include' };
    return await fetch(url, options).then((res) => (json ? res.json() : res.text()));
  };

  const applyBundlePricing = () => {
    const $quickViewContent = $('.quickview-content');
    const $productPrice = $quickViewContent.find('.product--price');
    const $productComparePrice = $quickViewContent.find('.product--title-price-compare');

    if ($productComparePrice.css('display') === 'none') {
      $productComparePrice.find('.money').text($productPrice.text());
      $productComparePrice.show();
    }

    const currentCollectionMetadata = window.bvaccel.bundleMultipleCollections.find((obj) => {
      return obj.collectionHandle === currentCollection;
    });

    $productPrice.text(`$${currentCollectionMetadata.collectionNewPrice}`);
  };

  const checkIfBundleCollection = () => {
    if (window.bvaccel.isBundleCollection) {
      applyBundlePricing();

      $('.quickview-product--details-cta').attr('target', '_blank').addClass('sm-hide');

      $('#AddToCartForm').on('submit', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();

        const $variantSelectorOption = $('.js-quickview-variant-selector option:selected');

        BundleCollection.addBundleProduct({
          variant_id: $variantSelectorOption.attr('value'),
          image: $variantSelectorOption.attr('data-img'),
          collection: currentCollection,
        });
        Modal.hide('quickview');
      });
    }
  };

  const initInitialVariant = () => {
    const availableVariant = currentQuickView.variants.find((variant) => {
      return variant.available && !currentQuickView.hide_color_variants.includes(variant.option1);
    });
    const variantId = availableVariant ? availableVariant.id : currentQuickView.variants[0].id;

    let colorName = currentQuickView.variants[0].option1;
    currentQuickView.variants.forEach(variant => {
      if(variant.id.toString() == variantId) {
        colorName = variant.option1;
      }
    });

    $(`.quickview-modal .js-quickview-variant-display-value[data-swatch-color]`).each(function(){
      if ($(this).data(`swatch-color`) && $(this).data(`value`) == colorName) {
        colorPrefix = $(this).data(`color-prefix`) || ``;
        changeVariantOption($(this));
      }
    });
  };

  const initQuickViewDependents = () => {
    // Init Quick View Product
    setTimeout(window.Sliders.initQuickviewFeaturedSlider, 0);
    initSettings();
    initDisabledSizes();
    filterVariants();
    checkIfBundleCollection();
  };

  const bindUIActions = () => {
    // Show/Hide Quick View CTA
    $dom.productImageWrapper.on('mouseover', (e) => {
      const $target = $(e.currentTarget);
      $target.find('.js-quickview-cta').addClass('is-active');
    });

    $dom.productImageWrapper.on('mouseout', (e) => {
      const $target = $(e.currentTarget);
      $target.find('.js-quickview-cta').removeClass('is-active');
    });

    // Show Quick View Modal
    $dom.quickViewCTA.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const target = $(e.currentTarget);
      const modal = $(`[data-modal = "${target.data('modal-open')}"]`);
      const modalContent = modal.find('.js-modal-content');
      const productHandle = target.data('modal-handle');
      const collectionHandle = target.data('collection-handle');

      modalContent.html('Loading...');

      loadModalContent(productHandle, 'quickshop').then((res) => {
        modalContent.html(res);
        currentQuickView = window.bvaccel.product;
        currentCollection = collectionHandle;
        if (window.Product && modalContent.find(`.js-product-variant-color`)) {
          window.Product.initColorGroups(modalContent.find(`.js-product-variant-color`), `quickview`, currentQuickView);
        }
        initQuickViewDependents();
        initInitialVariant();

        // insert logo
        let logoImage = document.querySelector(".global-header .logo-image img");
        if (logoImage) {
          logoImage = logoImage.cloneNode(true);
          logoImage.classList.add('quickview-logo');

          document.querySelector(".quickview-content").prepend(logoImage);
        }
      });
    });

    $(document).on('click', '.js-quickview-variant-display-value', function () {
      changeVariantOption($(this));
    });

    $(document).on('mouseenter', '[data-name="Color"] .js-quickview-variant-display-value', function () {
      const $element = $(this);
      const value = $element.data(`color-prefix`) ? `${$element.data('color-prefix')} ${$element.data('value')}` : $element.data(`value`);
      $(this)
        .closest('.product--variant-display-option')
        .find('.js-quickview-current-variant-option')
        .text(value);
    });

    $(document).on('mouseout', '[data-name="Color"] .js-quickview-variant-display-value', function () {
      const $displayList = $(this)
        .closest(".product--variant-display-list")
      const optionNum = $displayList.data(`option`);
      const optionName = $displayList.data(`name`);
      $(this)
        .closest('.product--variant-display-option')
        .find('.js-quickview-current-variant-option')
        .text(optionName === `Color` ? `${colorPrefix} ${quickViewSettings[optionNum].value}` : quickViewSettings[optionNum].value);
    });

    $(document).on('change', '.js-quickview-product-variant-option-selector', function () {
      const optionName = $(this).data('name');
      const optionNum = $(this).data('option');
      const value = $(this).val();
      const optionText = value.charAt(0).toUpperCase() + value.slice(1);
      quickViewSettings[optionNum].value = value;
      $(`.js-quickview-current-variant-option[data-name=${optionName}]`).text(
        optionName === `Color` ? `${colorPrefix} ${optionText}` : optionText
      );
      initDisabledSizes();
      filterVariants();
    });

    // Switch content to size guide
    $(document).on('click', '.js-quickview-size-guide-link', (e) => {
      e.preventDefault();
      const $target = $(e.currentTarget),
        $quickViewContainer = $target.closest('.quickview-content'),
        $quickViewClose = $quickViewContainer.find('.quickview-close');
      $quickViewContainer.addClass('show-size');
      $quickViewClose.attr('disabled', true).attr('aria-label', 'Back');
    });

    // Switch content to pricing disclaimer
    $(document).on('click', '.js-quickview-pricing-disclaimer-link', (e) => {
      e.preventDefault();
      const $target = $(e.currentTarget),
        $quickViewContainer = $target.closest('.quickview-content'),
        $quickViewClose = $quickViewContainer.find('.quickview-close');
      $quickViewContainer.addClass('show-pricing-disclaimer');
      $quickViewClose.attr('disabled', true).attr('aria-label', 'Back');
      $quickViewContainer.find('.quickview--pricing-disclaimer-content').trigger('focus');
    });

    // Switch content back to Quick View Product
    $(document).on('click', '[data-modal-close="quickview"]', (e) => {
      e.preventDefault();
      const $target = $(e.currentTarget),
        $quickViewModal = $target.closest('.quickview-modal'),
        $quickViewContainer = $quickViewModal.find('.quickview-content'),
        $quickViewClose = $quickViewContainer.find('.quickview-close');
      const wasShowingPricingDisclaimer = $quickViewContainer.hasClass('show-pricing-disclaimer');
      $quickViewClose.attr('disabled', false).attr('aria-label', 'Close');
      $quickViewContainer.removeClass('show-size show-pricing-disclaimer');
      if (wasShowingPricingDisclaimer && $quickViewModal.hasClass('is-active')) {
        $quickViewContainer.find('.js-quickview-pricing-disclaimer-link').trigger('focus');
      }
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  QuickView.init = init;
})((window.QuickView = window.QuickView || {}), jQuery);
